import { isUndefined } from '../isUndefined';

const numberValidator = (val: string) => {
    if (isUndefined(val)) {
        return { hasError: false };
    }

    const stringVal = val.toString();

    const regex = new RegExp(
        `^-?(?:\\d+|\\d{1,3}(?:,\\d{3})+)(?:(\\.|,)\\d+)?$`
    );
    const regexExec = regex.exec(stringVal);

    return {
        hasError:
            regexExec === null ||
            !(regexExec && regexExec.length > 0 && regexExec[0] === stringVal),
        message: 'Gegeven is geen nummer of bevat andere tekens',
    };
};

export default numberValidator;
